// Author : Vishnu
//Version :0.0.1
// MODIFIED DATE: 18/08/2025
import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/***************   Start Update Branch Meeting Date ******************/
export const ChangeBranchMeetingDateUpdate = (listData: any) => {
	const data = {
		UpdateBranchCentersMeetingDateDataToken: listData,
	};
	const url = `${API_URL}updateBranchMeetingDate`;
	return makeApiCall(url, data);
};

export const ChangeBranchMeetingDateUpdateAutoLoan = (listData: any) => {
	const data = {
		UpdateBranchCentersMeetingDateDataToken: listData,
	};
	const url = `${API_URL}updateBranchMeetingDateAutoLoan`;
	return makeApiCall(url, data);
};
/***************   End Update Branch Meeting Date ******************/

/***************   Get Branch Meeting Date Details Start ******************/
export const ChangeBranchMeetingDateGet = (listData: any) => {
	const data = {
		FetchBranchMeetingDateDetailsDataToken: listData,
	};
	const url = `${API_URL}getBranchMeetingDate`;
	return makeApiCall(url, data);
};

export const ChangeBranchMeetingDateGetAutoLoan = (listData: any) => {
	const data = {
		FetchBranchMeetingDateDetailsDataToken: listData,
	};
	const url = `${API_URL}getBranchMeetingDateAutoLoan`;
	return makeApiCall(url, data);
};
/***************   Get Branch Meeting Date Details End ******************/

/***************  Get Loan Center Group Details Start ******************/
export const FetchLoanCenterGroupDetails = (listData: any) => {
	const data = {
		LoanCenterGroupDetailsListToken: listData,
	};
	const url = `${API_URL}getLoanCenterGroup`;
	return makeApiCall(url, data);
};

export const FetchLoanCenterGroupDetailsAutoLoan = (listData: any) => {
	const data = {
		LoanCenterGroupDetailsListToken: listData,
	};
	const url = `${API_URL}getLoanCenterGroupAutoLoan`;
	return makeApiCall(url, data);
};
/***************  Get Loan Center Group Details End ******************/

/***************  Get Loan Index Details Based On Center Group Start ******************/
export const FetchLoanDetailsBasedOnCenterGroup = (listData: any) => {
	const data = {
		FetchLoanDetailsBasedOnCenterGroupToken: listData,
	};
	const url = `${API_URL}getLoanDetailsBasedOnCenterGroup`;
	return makeApiCall(url, data);
};

export const FetchLoanDetailsBasedOnCenterGroupAutoLoan = (listData: any) => {
	const data = {
		FetchLoanDetailsBasedOnCenterGroupToken: listData,
	};
	const url = `${API_URL}getLoanDetailsBasedOnCenterGroupAutoLoan`;
	return makeApiCall(url, data);
};
/***************  Get Loan Index Details Based On Center Group End ******************/

/***************   Start Update Branch New Meeting Date ******************/
export const ChangeSingleBranchMeetingDateUpdate = (listData: any) => {
	const data = {
		UpdateBranchMeetingDateToken: listData,
	};
	const url = `${API_URL}updateBranchNewMeetingDate`;
	return makeApiCall(url, data);
};

export const ChangeSingleBranchMeetingDateUpdateAutoLoan = (listData: any) => {
	const data = {
		UpdateBranchMeetingDateToken: listData,
	};
	const url = `${API_URL}updateBranchNewMeetingDateAutoLoan`;
	return makeApiCall(url, data);
};
/***************   End Update Branch New Meeting Date ******************/

/***************  Update Loan Index Meeting Date Time Start ******************/
export const ChangeSingleCenterMeetingDateUpdate = (listData: any) => {
	const data = {
		UpdateMeetingDateAndTimeForLoanIndexToken: listData,
	};
	const url = `${API_URL}updateLoanIndexMeetingDateTime`;
	return makeApiCall(url, data);
};

export const ChangeSingleCenterMeetingDateUpdateAutoLoan = (listData: any) => {
	const data = {
		UpdateMeetingDateAndTimeForLoanIndexToken: listData,
	};
	const url = `${API_URL}updateLoanIndexMeetingDateTimeAutoLoan`;
	return makeApiCall(url, data);
};
/***************  Update Loan Index Meeting Date Time End ******************/

/***************  Update Loan Index Meeting Date Time Member Wise Start ******************/
export const ChangeSingleMemberMeetingDateUpdate = (listData: any) => {
	const data = {
		UpdateMeetingDateTimeForLoanIndexMemberwiseToken: listData,
	};
	const url = `${API_URL}updateLoanIndexMeetingDateTimeMemberWise`;
	return makeApiCall(url, data);
};

export const ChangeSingleMemberMeetingDateUpdateAutoLoan = (listData: any) => {
	const data = {
		UpdateMeetingDateTimeForLoanIndexMemberwiseToken: listData,
	};
	const url = `${API_URL}updateLoanIndexMeetingDateTimeMemberWiseAutoLoan`;
	return makeApiCall(url, data);
};
/***************  Update Loan Index Meeting Date Time Member Wise End ******************/
